import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    marginBottom: theme.spacing(2),
  },
  iconWrapper: {
    minWidth: theme.spacing(9),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  iconWrapperCertification: {
    backgroundColor: theme.palette.primary.lighter,
  },
  iconWrapperMandatoryDocumentation: {
    backgroundColor: theme.palette.secondary.lighter,
  },
  iconWrapperSpecificDocumentation: {
    backgroundColor: theme.palette.secondary.lighter,
  },
  icon: {
    color: theme.palette.grey[200],
  },
  content: {
    padding: theme.spacing(2, 3),
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    flexDirection: 'column',

    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
    },
  },
  textsWrapper: {
    [theme.breakpoints.up('sm')]: {
      paddingRight: theme.spacing(2),
    },
  },
  infoText: {
    color: theme.palette.grey[200],
  },
  contentText: {
    color: theme.palette.grey[300],
    marginTop: theme.spacing(0.5),
  },
  badgeWrapper: {
    marginTop: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      marginTop: 0,
    },
  },
}))

export default useStyles
